import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const lightTheme = {
  dark: false,
  colors: {
    // Standard Vuetify slots
    primary: '#0b201f',           // --negro
    'on-primary': '#ffffff',
    secondary: '#757575',         // --negro-2
    'on-secondary': '#ffffff',
    surface: '#ffffff',           // --blanco
    'on-surface': '#0b201f',      // --texto
    background: '#f5f5f5',        // --fondo
    'on-background': '#0b201f',
    success: '#009951',           // --verde-oscuro
    error: '#c00f0c',             // --rojo-oscuro
    info: '#007aff',              // --azul-oscuro
    warning: '#ffcc00',           // --amarillo

    // Custom slots (project-specific tokens)
    green: '#00d97c',
    negro: '#0b201f',
    negro2: '#132827',
    fx: '#01ff94',                // --fx (neon green)
    fxSubtle: '#00d97c',          // --fx-2
    successContainer: '#cff7d3',  // --verde-claro
    errorContainer: '#fcb3ad',    // --rojo-claro
    errorContainer2: '#fdd3d0',   // --rojo-claro-2
    infoContainer: '#d9ebff',     // --azul-claro
    border: '#e3e3e3',            // --borde
    mutedText: '#757575',         // --texto-muted
    placeholderText: '#b3b3b3',   // --texto-placeholder
    oscuro500: '#435554',         // --oscuro-500
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: { light: lightTheme }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  defaults: {
    VMenu: {
      elevation: 0,
    },
  },
})
